import React, { useRef, useState } from 'react';
import { Button } from '@material-ui/core';
import BackupIcon from '@material-ui/icons/Backup';
import DialogComp from '../../../Core/Modal/dialogModal';

const InspectionImages = ({ state, setState, disabled, hideBtn }) => {
    const [img, setImg] = useState(false);
    const fileInputRef = useRef(null);

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const image = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                image.src = e.target.result;
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    const MAX_WIDTH = 800;
                    const scaleFactor = Math.min(MAX_WIDTH / image.width, 1);

                    canvas.width = image.width * scaleFactor;
                    canvas.height = image.height * scaleFactor;

                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

                    const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8);
                    setState((st) => ({ ...st, vehicleInspectionBrakeTestPhoto: compressedBase64 }));
                };
            };
            reader.readAsDataURL(file);
        }
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const openImag = () => {
        setImg(!img);
    };

    const removeImg = (e) => {
        e.stopPropagation();
        setState((st) => ({ ...st, vehicleInspectionBrakeTestPhoto: null }));
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, height: '100%' }}>
            <input
                type="file"
                accept="image/*, application/pdf, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleImageChange}
                ref={fileInputRef}
                style={{ display: 'none' }}
            />
            {!hideBtn && (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={handleButtonClick}
                    disabled={disabled}
                    startIcon={<BackupIcon />}
                    style={{
                        height: 38,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: 12,
                        padding: '6px 14px',
                        borderRadius: 4,
                        whiteSpace: 'nowrap',
                        backgroundColor: '#0284c7'
                    }}
                >
                    {state.vehicleInspectionBrakeTestPhoto ? 'Change Image' : 'Upload Image'}
                </Button>
            )}

            {state.vehicleInspectionBrakeTestPhoto && (
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <img
                        src={state.vehicleInspectionBrakeTestPhoto}
                        alt="Brake Test Preview"
                        style={{
                            width: 38,
                            height: 38,
                            borderRadius: 4,
                            border: '1px solid #cbd5e1',
                            objectFit: 'cover',
                            cursor: 'pointer',
                            backgroundColor: '#f8fafc'
                        }}
                        onClick={openImag}
                        title="Click to view full photo"
                    />
                    {!disabled && (
                        <div
                            onClick={removeImg}
                            style={{
                                position: 'absolute',
                                top: -6,
                                right: -6,
                                width: 16,
                                height: 16,
                                borderRadius: '50%',
                                backgroundColor: '#ef4444',
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.3)',
                                fontSize: 10,
                                fontWeight: 'bold'
                            }}
                            title="Remove photo"
                        >
                            ✕
                        </div>
                    )}
                </div>
            )}

            {img && (
                <DialogComp title="Brake Test Photo" onClose={openImag} maxWidth="sm" fullWidth>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 12, background: '#f8fafc' }}>
                        <img
                            src={state.vehicleInspectionBrakeTestPhoto}
                            alt="Uploaded Preview"
                            style={{ maxHeight: '70vh', maxWidth: '100%', objectFit: 'contain', borderRadius: 4 }}
                        />
                    </div>
                </DialogComp>
            )}
        </div>
    );
};

export default InspectionImages;
